module.exports = __webpack_public_path__ + "media/images/emoticons/info02-0369e38b290bfb851c2d450dc45b10fe.gif";